// Return a COPY of the list sorted by displayName. Copying is load-bearing: callers hold
// the list in React state, and Array.sort mutates in place — sorting the state array
// directly during render mutates shared (dev-frozen) state and can throw. (?? '') tolerates
// a missing displayName: the types say it's always present, but Graph can return null.
export const sortByDisplayName = <T extends { displayName?: string }>(list: T[]): T[] =>
  [...list].sort((a, b) => (a.displayName ?? '').localeCompare(b.displayName ?? ''));
